import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OpenIdService } from 'src/app/service/open-id.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
    public loginUrl: string;
    constructor(
        @Inject(DOCUMENT) public document: Document,
        private route: ActivatedRoute,
        private openIdService: OpenIdService
    ) {
        let options = {
            redirectUri: this.document.location.origin,
        };
        this.loginUrl = this.openIdService.keycloak.createLoginUrl(options);
    }

    ngOnInit(): void {}
}
